import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";

const HOWTO = {
  ios: "Settings → Safari → Microphone / Location → Allow, then reload.",
  android: "Tap the lock icon in the address bar → Permissions → allow, then reload.",
  desktop: "Click the lock/tune icon left of the URL → allow Microphone / Location, then reload.",
};
const platform = () => (/iPad|iPhone|iPod/.test(navigator.userAgent) ? "ios" : /Android/.test(navigator.userAgent) ? "android" : "desktop");

export const usePermission = (name) => {
  const [state, setState] = useState("unknown");
  useEffect(() => {
    let p;
    navigator.permissions?.query?.({ name }).then((s) => { p = s; setState(s.state); s.onchange = () => setState(s.state); }).catch(() => setState("unknown"));
    return () => { if (p) p.onchange = null; };
  }, [name]);
  return [state, setState];
};

export const PermissionCard = ({ kind, state, fallback, onAsk }) => {
  if (state === "granted" || state === "unknown") return null;
  const label = kind === "microphone" ? "microphone" : "location";
  if (state === "prompt") return (
    <div className="perm-card" data-testid={`perm-${kind}-prompt`}>
      <p className="text-sm">DropIt needs your {label} {kind === "microphone" ? "to turn speech into a job card." : "to drop the pin where you're standing."}</p>
      <button type="button" className="btn-secondary mt-2" onClick={onAsk} data-testid={`perm-${kind}-ask`}>Allow {label}</button>
    </div>
  );
  return (
    <div className="perm-card perm-denied" data-testid={`perm-${kind}-denied`}>
      <p className="flex items-center gap-2 text-sm font-semibold"><ShieldAlert size={16} /> {label[0].toUpperCase() + label.slice(1)} is blocked</p>
      <p className="text-xs text-muted mt-1">{HOWTO[platform()]}</p>
      <p className="text-xs mt-2">{fallback}</p>
    </div>
  );
};
